export const createCodingAnalysis = /* GraphQL */ `
  mutation CreateCodingAnalysis($input: CreateCodingAnalysisInput!) {
    createCodingAnalysis(input: $input) {
      id
      userId
      caseName
      patientReference
      inputDocumentKeys
      processingStatus
      resultJson
      errorJson
      createdAt
      updatedAt
    }
  }
`;

export const updateCodingAnalysis = /* GraphQL */ `
  mutation UpdateCodingAnalysis($input: UpdateCodingAnalysisInput!) {
    updateCodingAnalysis(input: $input) {
      id
      userId
      caseName
      patientReference
      inputDocumentKeys
      processingStatus
      resultJson
      errorJson
      createdAt
      updatedAt
    }
  }
`;

export const deleteCodingAnalysis = /* GraphQL */ `
  mutation DeleteCodingAnalysis($input: DeleteCodingAnalysisInput!) {
    deleteCodingAnalysis(input: $input) {
      id
      userId
      caseName
      patientReference
      inputDocumentKeys
      processingStatus
      resultJson
      errorJson
      createdAt
      updatedAt
    }
  }
`;

export const listCodingAnalyses = /* GraphQL */ `
  query ListCodingAnalyses(
    $filter: ModelCodingAnalysisFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCodingAnalyses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        caseName
        patientReference
        inputDocumentKeys
        processingStatus
        resultJson
        errorJson
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
